import {
  EXPERT_TIPS_COLORS,
  EXPERT_TIPS_RESPONSIVE,
  EXPERT_TIPS_TYPOGRAPHY,
} from './constants';
import type { ExpertTipLinkResource } from '../../types/expert-tip.types';

interface TipLinkResourcesProps {
  linkResources: ExpertTipLinkResource[];
}

function getDomain(url: string): string {
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
}

function FaviconFallback({ className }: { className: string }) {
  return (
    <div
      className={`${className} rounded-full flex items-center justify-center`}
      style={{ backgroundColor: EXPERT_TIPS_COLORS.lighterBlue }}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke={EXPERT_TIPS_COLORS.darkBlue}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    </div>
  );
}

export default function TipLinkResources({ linkResources }: TipLinkResourcesProps) {
  return (
    <div className="flex flex-col" style={{ gap: '12px' }}>
      <h4
        className={`font-semibold ${EXPERT_TIPS_TYPOGRAPHY.furtherReadingTitle}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: EXPERT_TIPS_COLORS.textPrimary,
          margin: 0,
        }}
      >
        Further reading
      </h4>

      <div className="flex flex-col" style={{ gap: '10px' }}>
        {linkResources.map((resource) => {
          const domain = getDomain(resource.url);
          const faviconUrl = `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;

          return (
            <a
              key={resource.id}
              href={resource.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center no-underline"
              style={{ gap: '10px' }}
            >
              <img
                src={faviconUrl}
                alt=""
                className={`rounded-full object-cover flex-shrink-0 ${EXPERT_TIPS_RESPONSIVE.linkLogoSizeClasses}`}
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                  (e.target as HTMLImageElement).nextElementSibling?.classList.remove('hidden');
                }}
              />
              <FaviconFallback
                className={`hidden flex-shrink-0 ${EXPERT_TIPS_RESPONSIVE.linkLogoSizeClasses}`}
              />

              <div className="flex flex-col min-w-0">
                <span
                  className={`font-normal truncate ${EXPERT_TIPS_TYPOGRAPHY.linkResourceTitle}`}
                  style={{
                    fontFamily: 'DM Sans, sans-serif',
                    color: EXPERT_TIPS_COLORS.textPrimary,
                  }}
                >
                  {resource.title}
                </span>
                <span
                  className="text-xs truncate"
                  style={{
                    fontFamily: 'DM Sans, sans-serif',
                    color: EXPERT_TIPS_COLORS.textSecondary,
                  }}
                >
                  {domain}
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
